module.exports = __webpack_public_path__ + "static/img/city-gold-ar.692e648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-gold-ar.png
// module id = 1063
// module chunks = 173